import { render, staticRenderFns } from "./InputPasswordBase.vue?vue&type=template&id=d2ae45cc&scoped=true&lang=pug&"
import script from "./InputPasswordBase.vue?vue&type=script&lang=ts&"
export * from "./InputPasswordBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae45cc",
  null
  
)

export default component.exports